import { render } from "./EmailInput.vue?vue&type=template&id=2d027ebc&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"

import "./EmailInput.vue?vue&type=style&index=0&id=2d027ebc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d027ebc"]])

export default __exports__